<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini" :model="searchForm">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="queryTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属小队:" >
          <el-select v-model="searchForm.teamCode" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机:" >
          <el-select v-model="searchForm.driverName" filterable placeholder="请选择" clearable  >
            <el-option v-for="item in sijiList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border :cell-style="setCellStyle" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="driverName" width="" label="司机"></el-table-column>
        <el-table-column prop="vehicleNos" width="" label="车牌号"></el-table-column>
        <el-table-column prop="teamName" width="" label="所属小队"></el-table-column>
        <el-table-column prop="workStart" width="" label="工作开始时间"></el-table-column>
        <el-table-column prop="workEnd" width="" label="工作结束时间"></el-table-column>
        <el-table-column prop="totalWorkDuration" width="" label="总工作时长"></el-table-column>
        <el-table-column prop="totalWayCount" width="" label="趟数"></el-table-column>
        <el-table-column prop="totalUnloadAmount" width="" label="总卸车量"></el-table-column>
        <el-table-column prop="avgUnloadAmount" width="" label="平均卸车量"></el-table-column>
        <el-table-column prop="totalMileage" width="" label="总行驶里程"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { dailyWork } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { organizationTree, cDlists } from '@/api/vgs-driver2.0'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      queryTime: [],
      searchForm: {},
      tableList: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      XDList: [],
      isDaoChu: false,
      sijiList: [],
      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
        // 当选择了开始时间后，限制结束时间只能选择同一天
          if (minDate && !maxDate) {
            const minDateStr = this.formatDateOnly(minDate)
            this.pickerOptions.disabledDate = (time) => {
            // 只能选择与开始时间同一天的范围
              return this.formatDateOnly(time) !== minDateStr
            }
          } else {
          // 重置限制
            this.pickerOptions.disabledDate = null
          }
        },
        disabledDate: null
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/realTimeVehicle')
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    this.initQueryTime()
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  watch: {
    queryTime (newVal) {
      if (newVal && newVal.length === 2) {
        const startDate = new Date(newVal[0])
        const endDate = new Date(newVal[1])

        // 如果开始时间不是00:00:00，则修正
        if (startDate.getHours() !== 0 || startDate.getMinutes() !== 0 || startDate.getSeconds() !== 0) {
          startDate.setHours(0, 0, 0, 0)
          newVal[0] = this.formatDateTime(startDate)
        }

        // 如果结束时间不是23:59:59，则修正
        if (endDate.getHours() !== 23 || endDate.getMinutes() !== 59 || endDate.getSeconds() !== 59) {
          endDate.setHours(23, 59, 59, 999)
          newVal[1] = this.formatDateTime(endDate)
        }

        // 如果修正了值，需要重新赋值触发更新
        if (newVal[0] !== this.queryTime[0] || newVal[1] !== this.queryTime[1]) {
          this.$nextTick(() => {
            this.queryTime = [...newVal]
          })
        }
      }
    }
  },
  methods: {
    xiaoduiChange (e) {
      let json = this.XDList.filter(item => e == item.code)
      this.getList(json[0].id)
    },
    getList (teamOrgId) {
      let searchFrom = {
        pageNo: 1,
        pageSize: 1000,
        teamOrgId: teamOrgId,
        driverClassify: 2
      }
      cDlists(searchFrom).then(res => {
        this.sijiList = res.list
      })
    },
    formatDateOnly (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getYesterdayRange () {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)

      // 设置开始时间为昨天的 00:00:00
      const start = new Date(yesterday)
      start.setHours(0, 0, 0, 0)

      // 设置结束时间为昨天的 23:59:59
      const end = new Date(yesterday)
      end.setHours(23, 59, 59, 999)

      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },

    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    initQueryTime () {
      const { startTime, endTime } = this.getYesterdayRange()
      this.queryTime = [startTime, endTime]
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.projectType === '合计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    masterList () {
      if (this.queryTime) {
        this.$set(this.searchForm, 'startTime', this.queryTime[0])
        this.$set(this.searchForm, 'endTime', this.queryTime[1])
      } else {
        this.$set(this.searchForm, 'startTime', '')
        this.$set(this.searchForm, 'endTime', '')
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      dailyWork(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res.list
          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {}
      this.initQueryTime()
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/tWayVehicleReport/exportDailyWork',
        form,
        '司机日工作情况'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
